<template>
<!--Footer-->
<div id="footer">
  <div id="content_footer">
    <!--copyright-->
    <div id="copyright">&copy; 2009-{{year}} StumptheSpread.com</div>
    <!--copyright ends-->
    <!--Back to top button-->
    <div id="back_to_top" v-if="!isLogin">
      <a href="#" @click.prevent="scrollToTop">
        <div class="sprite back_to_top" style="display:inline-block" title="Back to the Top"></div>
      </a>
    </div>
    <!--Back to top button Ends-->
  </div>
</div>
<!--Footer Ends-->
</template>

<script>
export default {
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  computed: {
    isLogin () {
      return this.$route.name === 'login'
    }
  },
  methods: {
    // Replaces a jQuery handler in index.html that bound at document.ready,
    // before Vue had rendered this footer, so it never actually attached.
    scrollToTop () {
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({top: 0, behavior: 'smooth'})
      } else {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// StsFooter.vue?0fda3e83